import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import SupportInfo from '../components/Common/SupportInfo';
const PublicLayout = ({ children }) => {
  const commonReducers = useSelector((state) => state.commonReducers);
  const privacyPolicy = commonReducers.constantsData?.adminPrivacyPolicy;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ background: 'linear-gradient(135deg, #fff0e7 0%, #fecdbc 100%)' }}>
      <Box p={2} sx={{ width: '50%' }}>
        <SupportInfo />
      </Box>
      <Box
        sx={{
          width: '50%',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
          position: 'relative',
        }}>
        <Box className="content-animation" width={{ xs: 320, md: 420, lg: 500 }}>
          <Box
            width={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center">
            {children}
          </Box>
        </Box>
        <Box px={2} pt={2} pb={1} sx={{ position: 'fixed', bottom: 2 }}>
          <Typography component="span" sx={{ fontSize: 12 }}>
            Beauty Book® brought to you by Aesthetics Skincare Australia Pty Ltd
          </Typography>
          <a
            target="_blank"
            href={privacyPolicy}
            style={{ textDecoration: 'none', paddingLeft: 12 }}
            className="link text-primary cursor-pointer font-12"
            rel="noreferrer">
            Privacy Policy
          </a>
        </Box>
      </Box>
    </Box>
  );
};

export default PublicLayout;
